<template>
    <div class="pb4">

        <div :class=" {'flex justify-end' : isRight }" class="mb2">
            <div :class="messageStyle()" :style="'max-width:' + messageMaxWidth" class="dib ba b--light-gray" >
                <slot></slot> 
            </div> 
        </div>

        <div class="flex items-center" :class="{'justify-end' : isRight }">
            <img class="w2 h2" :class="{'order-last pl2' : isRight }" :src="require('@/assets/img/avatars/' + avatar)"/>
            <div class="formLabel mid-gray pl2">{{date | moment("MMM DD [at] h:mma")}}</div>
        </div>

    </div>    
</template>

<script>
export default {
    props: {
        isRight: {
            type: Boolean
        },
        date: {
            type: String
        },
        avatar: {
            type: String
        }
    },
    methods: {
        messageStyle() {
            return this.isRight ? 'bg-light-gray right' : 'bg-white left';
        }
    },
    computed: {
        messageMaxWidth() {
            switch (this.$mq) {
                case 'xs':
                    return '90%';
                case 'sm':
                    return '65%';
                case 'md':
                    return '90%';
                case 'lg':
                    return '60%';
            }
        }
    }
};
</script>

<style scoped>
.left {
    background-color: white;
    border-radius: 10px 10px 10px 0px;
    box-shadow: 0px 1px 4px 0px #b1b9bf;
}
.right {
    border-radius: 10px 10px 0px 10px;
}
</style>
